module.exports = __webpack_public_path__ + "img/404.613f16a7.png";